import script from "./VInputCheckboxGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./VInputCheckboxGroup.vue?vue&type=script&setup=true&lang=ts"

import "./VInputCheckboxGroup.vue?vue&type=style&index=0&id=beaf6166&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-beaf6166"]])

export default __exports__